export type BinderSubmissionStatus = 'processing' | 'failed' | 'ready' | 'confirmed' | 'discarded';

export interface ExternalPolicyBinderSubmission {
  submissionId: number;
  accountId: number;
  documentId: string;
  documentName: string;
  invocationId: string;
  status: BinderSubmissionStatus;
  errorMessage?: string;
  promptResultId?: number;
  createdPolicyIds?: number[];
  submittedBy: string;
  submittedAt: string;
  resolvedAt?: string;
}

export interface ConfirmBinderResponse {
  validPolicy: boolean;
  messages: string[];
  createdPolicyIds?: number[];
}

export const MAX_BINDER_SIZE_BYTES = 25 * 1024 * 1024;
export const MAX_BINDERS_PER_BATCH = 20;
// A full batch is up to 500 MB of multipart POSTs. Past a few in flight the browser queues
// them anyway, and gateway throttling turns the surplus into opaque per-file failures.
export const MAX_CONCURRENT_BINDER_UPLOADS = 4;

export type BinderBatchResult =
  | { file: File; outcome: 'queued'; submission: ExternalPolicyBinderSubmission }
  | { file: File; outcome: 'duplicate'; existingSubmissionId: number | null }
  | { file: File; outcome: 'rejected'; reason: string; retryable?: boolean };

// One selectable reference value and the group it rolls up to. A policy line stores the
// child entity, so the group travels with the option instead of being a second thing to pick.
export interface ExternalPolicyEntityOption {
  name: string;
  groupName: string;
}

// Reference values a reviewer may pick from when correcting what an extraction resolved.
export interface ExternalPolicyEntityOptions {
  issuingCompanies: ExternalPolicyEntityOption[];
  coverageTypes: string[];
  wholesalers: ExternalPolicyEntityOption[];
}
